<template>
  <v-row class="w-100" no-gutters>
    <v-col cols="2" class="my-auto">
      <v-card class="d-flex" :height="height" :width="width" flat>
        <v-row v-if="img === null" class="placeholder-rectangle rounded-small" no-gutters />
        <v-img v-else class="rounded-small" :src="img" :height="height" :width="width" alt="Thumbnail Image">
          <template v-slot:placeholder>
            <v-row
              class="fill-height mx-auto"
              align="center"
              justify="center"
              no-gutters
            >
              <v-progress-circular class="mx-auto my-auto" indeterminate color="#033e8c"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-card>
    </v-col>
    <v-col class="pl-4" cols="10" sm="8">
      <v-row no-gutters>
        <h5 class="d-inline-block mb-0 title text-truncate" v-html="highlight"></h5>
      </v-row>
      <v-row no-gutters>
        <span class="category text-right">{{ $t(`searchPage.categories[${document_type_id}]`) }}</span>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SearchResultEntry",
  props: {
    text: {
      type: String,
      default: ""
    },
    data_id: {
      type: Number,
      default: -1
    },
    document_type_id: {
      type: Number,
      default: -1
    },
    keyword: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: "39px"
    },
    width: {
      type: String,
      default: "60px"
    },
  },
  data () {
    return {
      texts: null,
    }
  },
  computed: {
    highlight: function () {
      return this.text ? this.text.replace(new RegExp(this.keyword, "gi"), (match) => `<span class="keyword">${match}</span>`) : null
    }
  },
  created() {
    const url = '/Documents/get?is_thumb=1&document_type_id=' + this.document_type_id + '&data_id=' + this.data_id
    this.axios.get(url, {} , { withCredentials: true})
    .then(response => {
      this.img = response.data.data[0].data_doc_raw
    })
    .catch(error => {
      this.img = null
      console.log(error)
    })
  },
}
</script>

<style scoped>
.title {
  font-size: 1.125rem;
  color: #8798AD;
}

.title >>> .keyword {
  color: black !important;
}

.placeholder-rectangle {
  background-color: #C4C4C4;
}

.rounded-small {
  border-radius: 0.1875rem;
}

.rounded-small >>> .v-image__image {
  border-radius: 0.1875rem;
}

.category {
  font-size: 0.8125rem;
  color: #8798AD;
  opacity: 0.5;
  width: 100%;
}
</style>